import { Action } from '@ngrx/store';
import {
    WORKPLACES_FETCH,
    WORKPLACES_FETCH_MORE,
    WORKPLACE_CREATE,
    WORKPLACE_DELETE,
    WORKPLACE_DELETE_START,
    WORKPLACE_ENTITY_SET,
    WORKPLACE_FETCH,
    WORKPLACE_UPDATE,
    WORKPLACE_VIEWED_SET
} from '../action-types';
import { ObservableAction } from '../shared/actions/observable-action';
import {
    ListItemSetAction,
    ListItemUnsetAction,
    ListMergeAction,
    ListSetAction,
    ListSetFetchingAction,
    ListSetFetchingMoreAction
} from '../shared/list/list.actions';
import { SharedAction } from '../shared/actions/shared-action';
import { GROUP_WORKPLACE } from '../state-groups';
import { WORKPLACE_ENTITY } from '../entity-types';

export class FetchWorkplacesAction implements Action {
    readonly type = WORKPLACES_FETCH;
}

export class FetchMoreWorkplacesAction implements Action {
    readonly type = WORKPLACES_FETCH_MORE;
}

export class SetWorkplacesFetchingAction
    extends ListSetFetchingAction
    implements SharedAction {
    name = GROUP_WORKPLACE;

    constructor(payload: boolean) {
        super(payload);
    }
}

export class SetWorkplacesFetchingMoreAction
    extends ListSetFetchingMoreAction
    implements SharedAction {
    name = GROUP_WORKPLACE;

    constructor(payload: boolean) {
        super(payload);
    }
}

export class SetWorkplacesAction
    extends ListSetAction
    implements SharedAction {
    name = GROUP_WORKPLACE;

    constructor(payload: any) {
        super(payload);
        payload.domain = WORKPLACE_ENTITY;
    }
}

export class MergeWorkplacesAction
    extends ListMergeAction
    implements SharedAction {
    name = GROUP_WORKPLACE;

    constructor(payload: any) {
        super(payload);
        payload.domain = WORKPLACE_ENTITY;
    }
}

export class SetWorkplaceAction
    extends ListItemSetAction
    implements SharedAction {
    name = GROUP_WORKPLACE;

    constructor(payload: any) {
        super(payload);
        payload.domain = WORKPLACE_ENTITY;
    }
}

export class SetViewedWorkplaceAction implements Action {
    readonly type = WORKPLACE_VIEWED_SET;

    constructor(public payload: {
        workplaceId: string
    }) {}
}

@ObservableAction()
export class UpdateWorkplaceAction implements Action {
    readonly type = WORKPLACE_UPDATE;

    constructor(
        public payload: {
            locationId: string;
            request: any; /// WorkplaceUpdateRequest
        }
    ) {}
}

@ObservableAction()
export class CreateWorkplaceAction implements Action {
    readonly type = WORKPLACE_CREATE;

    constructor(
        public payload: {
            request: any; /// WorkplaceCreateRequest
        }
    ) {}
}

@ObservableAction()
export class DeleteWorkplaceAction implements Action {
    readonly type = WORKPLACE_DELETE;

    constructor(
        public payload: {
            workplaceId: string;
        }
    ) {}
}

export class RemoveWorkplaceAction
    extends ListItemUnsetAction
    implements SharedAction {
    name = GROUP_WORKPLACE;

    constructor(payload: any) {
        super(payload);
        payload.domain = WORKPLACE_ENTITY;
    }
}